export const CINETPAY_ATTEMPT_PREFIX = "ql_teacher_cinetpay_attempt_";
export const CINETPAY_TERMINAL_STATES = new Set(["SUCCESS", "FAILED", "EXPIRED", "CANCELLED"]);
export const CINETPAY_ACTIVE_STATES = new Set(["PENDING", "PROCESSING"]);
export const CINETPAY_CHECKABLE_STATES = new Set(["INITIALIZING", "UNCERTAIN", "PENDING", "PROCESSING"]);
export const CINETPAY_CREATION_LOCKED_STATES = new Set(["INITIALIZING", "UNCERTAIN", "PENDING", "PROCESSING"]);

export const cinetPayStorageKey = (examId) => `${CINETPAY_ATTEMPT_PREFIX}${examId}`;

export const normalizeCinetPayStatus = (data) => String(
  data?.payment_status || data?.status || data?.payment?.status || "PROCESSING"
).toUpperCase();

export const readCinetPayAttempt = (examId) => {
  try {
    const value = JSON.parse(localStorage.getItem(cinetPayStorageKey(examId)) || "null");
    return value?.examId === Number(examId) && value?.key ? value : null;
  } catch {
    return null;
  }
};

export const persistCinetPayAttempt = (attempt) => {
  localStorage.setItem(cinetPayStorageKey(attempt.examId), JSON.stringify(attempt));
};

export const clearCinetPayAttempt = (examId) => localStorage.removeItem(cinetPayStorageKey(examId));

export const restoredCinetPayState = (attempt) => {
  const uncertain = attempt?.status === "INITIALIZING";
  return {
    status: uncertain ? "UNCERTAIN" : attempt?.status || "PROCESSING",
    error: uncertain ? "Le statut de l’initialisation n’a pas encore pu être confirmé." : null,
    checking: false,
    paymentUrl: attempt?.paymentUrl || null,
    nextAction: "CHECK_STATUS",
  };
};

export const canCheckCinetPayStatus = (status) => CINETPAY_CHECKABLE_STATES.has(status);
export const isCinetPayCreationLocked = (status) => CINETPAY_CREATION_LOCKED_STATES.has(status);

export const claimCinetPayInitialization = (lock, status) => {
  if (lock.current || isCinetPayCreationLocked(status)) return false;
  lock.current = true;
  return true;
};

export const releaseCinetPayInitialization = (lock) => {
  lock.current = false;
};
